<template>
    <!-- 指定商品 弹窗 -->
    <el-dialog title="选择商品" :visible.sync="visible" custom-class="dialog-table-select">
        <!-- filter -->
        <div class="filter">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm" class="filter-form">
                <el-form-item label="" prop="type" style="margin-right: 10px;">
                    <el-select v-model="filterForm.type" @change="handleFilterTypeChange">
                        <el-option label="全部" value="0"></el-option>
                        <template v-for="row in categoryOptions">
                            <el-option :label="row.name" :value="row.id" :key="row.id"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item label="" prop="relateId" style="margin-right: 10px;">
                    <el-select v-model="filterForm.relateId" placeholder="" :loading="relateLoading">
                        <el-option v-for="(item, index) in relateOptions" :key="item.relateId" :label="item.name" :value="'' + item.relateId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" prop="commodityName" class="auto-width">
                    <el-input v-model="filterForm.commodityName" placeholder="输入商品名称"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="filterFormSubmit('filterForm')" :loading="tableLoading">查询</el-button>
                    <el-button type="default" plain @click="filterFormReset('filterForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- table -->
        <div class="table-region" v-loading="tableLoading">
            <el-table size="small" :data="tableData" ref="multipleTable" @select="handleTableSelectionRowToggle" @select-all="handleTableSelectionAllToggle" :class="limit > 0 ? 'no-checkbox' : ''">
                <el-table-column type="selection" width="42"></el-table-column>
                <el-table-column label="商品" width="220">
                    <template slot-scope="scope">
                        <div class="select-mask" style="position: absolute; z-index: 3; top: 0; right: 0; bottom: 0; left: -42px; width: 42px; background: #FFF;" v-if="multipleSelection.indexOf(scope.row.id) == -1 && limit > 0 && multipleSelection.length > limit - 1"></div>

                        <div class="dialog-goods-title">
                            <div class="thumb-wrap">
                                <img :src="scope.row.mainPic">
                            </div>
                            <p>{{ scope.row.name }}</p>
                            <p>¥{{ scope.row.price }}</p>
                        </div>
                    </template>
                </el-table-column>
                <template v-if="limit === 1">
                    <el-table-column label="规格" width="180">
                        <template slot-scope="scope">
                            <el-form size="small" :inline="true" class="filter-form">
                                <template v-if="scope.row.sku.specificationList[0]">
                                    <el-form-item label="" style="margin-bottom: 6px">
                                    <el-select v-model="scope.row.firstValue">
                                        <template v-for="row in scope.row.sku.specificationList[0].valueNameList">
                                            <el-option :label="row.name" :value="row.name" :key="row.name"></el-option>
                                        </template>
                                    </el-select>
                                    </el-form-item>
                                </template>
                                <template v-if="scope.row.sku.specificationList[1]">
                                    <el-form-item label="" style="margin-bottom: 6px">
                                    <el-select v-model="scope.row.secondValue">
                                        <template v-for="row in scope.row.sku.specificationList[1].valueNameList">
                                            <el-option :label="row.name" :value="row.name" :key="row.name"></el-option>
                                        </template>
                                    </el-select>
                                    </el-form-item>
                                </template>
                                <template v-if="scope.row.sku.specificationList[2]">
                                    <el-form-item label="" style="margin-bottom: 6px">
                                    <el-select v-model="scope.row.thirdValue">
                                        <template v-for="row in scope.row.sku.specificationList[2].valueNameList">
                                            <el-option :label="row.name" :value="row.name" :key="row.name"></el-option>
                                        </template>
                                    </el-select>
                                    </el-form-item>
                                </template>
                            </el-form>
                        </template>
                    </el-table-column>
                    <el-table-column label="价格" width="100">
                        <template slot-scope="scope">
                            <p>￥{{ getProp(scope.row, 'price') }}</p>
                            <p>₩{{ getProp(scope.row, 'koreaPrice') }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="库存" width="80">
                        <template slot-scope="scope">
                            <p>{{ getProp(scope.row, 'stock') }}</p>
                        </template>
                    </el-table-column>
                </template>
                <template v-else>
                    <el-table-column label="商品类目">
                        <template slot-scope="scope">
                            <p v-for="(item, index) in scope.row.category" :key="index">{{ item }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="库存" width="80">
                        <template slot-scope="scope">
                            <p>{{ scope.row.stock }}</p>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="总销量" width="60">
                    <template slot-scope="scope">
                        <p>{{ scope.row.sale || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="已关联活动">
                    <template slot-scope="scope">
                        <p>{{ scope.row.moduleList.join('，') }}</p>
                    </template>
                </el-table-column>
            </el-table>

            <div class="table-footer" v-if="page.total > 0">
                <div class="selection-operate"></div>

                <div class="pagination-wrap">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :page-sizes="[20, 50, 100]"
                        :current-page="page.current"
                        :page-size="page.size"
                        layout="total, prev, pager, next, jumper"
                        :total="page.total">
                    </el-pagination>
                </div>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <p class="selected-total">已选 <span class="color-red">{{ multipleSelection.length }}</span></p>
            <el-button size="small" plain @click="visible = false">取 消</el-button>
            <el-button size="small" type="primary" @click="handleSelectionEnsure">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import { COMMON, commodityFilterOptions, commodityFilterList, moduleCategoryList } from '@/common/api'

    export default {
        props: {
            ids: { // 选中的数据
                type: Array,
                default: []
            },
            limit: {
                type: Number,
                default: 0
            },
            specs: { // 选中的规格id，和ids对应，目前只考虑了limit===1的情况，只会有一个规格，如需支持多个，需要改造逻辑
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                visible: false,

                filterForm: {
                    type: '0',
                    relateId: '',
                    commodityName: ''
                },

                categoryLoading: false,
                categoryOptions: [],

                relateLoading: false,
                relateOptions: [{
                    name: '全部',
                    relateId: ''
                }], // 下拉框二级

                tableLoading: true,
                tableData: [], //表格数据
                page: {
                    current: 1,
                    size: 5,
                    total: 0 
                },

                multipleSelection: this.ids,
                specSelection: this.specs
            }
        },
        watch: {
            'ids': function(val) {
                this.multipleSelection = this.ids;
            },
            'specs': function(val) {
                this.specSelection = this.specs;
            }
        },
        computed: {
            getProp(row, prop) {
                return function(row, prop) {
                    const list = row.sku.specificationDetailList
                    for(let i = 0; i < list.length; i++) {
                        const record = list[i]
                        if(row.firstValue == record.firstValue && row.secondValue == record.secondValue && row.thirdValue == record.thirdValue) {
                            return record[prop]
                        }
                    }
                    return 0
                }
            }
        },
        methods: {
            /**
             * [getCategoryList description] 类目 - 列表
             * @return {[type]} [description]
             */
            getCategoryList: function() {
                this.categoryLoading = true;

                let params = {
                    catType: 2,
                    current: 1,
                    size: 10000
                }

                moduleCategoryList(params).then(res =>{
                    this.categoryLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data.records || [];

                        // if(dataArray.length > 0) {
                        //     for(let i = 0; i < dataArray.length; i++) {
                        //         dataArray[i].upVisible = true;
                        //     }
                        // }

                        this.categoryOptions = dataArray;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [handleDialogShow description] 弹窗 - 显示
             * @return {[type]} [description]
             */
            handleDialogShow: function() {
                this.visible = true;
                this.filterForm.type = '0';
                this.filterForm.content = '';
                this.page.current = 1;
                this.tableData = [];

                this.getList();
            },
            handleFilterTypeChange: function(val) {
                this.relateOptions = [{
                    name: '全部',
                    relateId: ''
                }];
                this.filterForm.relateId = '';

                if(!val) {
                    return false;
                }

                this.categoryOptions.map(row => {
                    if(row.id == val) {
                        const options = []
                        row.secondCategoryListVos.map(item => {
                            options.push({
                                name: item.name,
                                relateId: item.id
                            })
                        })
                        this.relateOptions = this.relateOptions.concat(options)
                    }
                })


                // this.relateLoading = true;

                // let params = {
                //     type: val
                // }

                // commodityFilterOptions(params).then(res =>{
                //     let { code, data, msg } = res;

                //     if(code == 0) {
                //         this.relateLoading = false;

                //         let dataArray = data || [];

                //         this.relateOptions = this.relateOptions.concat(dataArray)
                //     } else {
                //         this.$message.error(msg);
                //     }
                // }).catch(error => {
                //     this.$message.error('服务器异常');
                // });
            },
            /**
             * [filterFormSubmit description] 弹窗 - 提交筛选表单
             * @param  {[type]} formName [description]
             * @return {[type]}          [description]
             */
            filterFormSubmit: function(formName) {
                this.page.current = 1;

                this.getList();
            },
            /**
             * [filterFormReset description] 弹窗 - 重置筛选表单
             * @param  {[type]} formName [description]
             * @return {[type]}          [description]
             */
            filterFormReset: function(formName) {
                this.$refs[formName].resetFields();
            },
            /**
             * [getList description] 弹窗 - 获取列表
             * @return {[type]} [description]
             */
            getList: function() {
                this.tableLoading = true;

                let params = {
                    all: 1,
                    type: this.filterForm.type,
                    relateId: this.filterForm.relateId,
                    commodityName: this.filterForm.commodityName,
                    current: this.page.current,
                    size: this.page.size
                }

                commodityFilterList(params).then(res =>{
                    this.tableLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data.records || [];
                        if(this.limit === 1) {
                            if(dataArray && dataArray.length > 0) {
                                dataArray.map((row, rowIndex) => {
                                    if(this.multipleSelection.length > 0) {
                                        if(row.id === this.multipleSelection[0]) {
                                            row.sku.specificationDetailList.map(record => {
                                                if(record.id == this.specs[0]) {
                                                    Object.assign(row, {
                                                        firstValue: record.firstValue,
                                                        secondValue: record.secondValue,
                                                        thirdValue: record.thirdValue
                                                    })
                                                }
                                            })
                                        }
                                    } else {
                                        const defaultSku = row.sku.specificationDetailList[0]
                                        Object.assign(row, {
                                            firstValue: defaultSku.firstValue,
                                            secondValue: defaultSku.secondValue,
                                            thirdValue: defaultSku.thirdValue
                                        })
                                    }
                                })
                            }
                        }

                        this.tableData = dataArray;
                        this.page.total = data.total;

                        this.$nextTick(() => {
                            if(dataArray.length > 0) {
                                let ids = this.multipleSelection;

                                for(let i = 0; i < dataArray.length; i++) {
                                    if(ids.indexOf(dataArray[i].id) > -1) {
                                        this.$refs.multipleTable.toggleRowSelection(dataArray[i], true);
                                    }
                                }
                            }
                        })
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [handleCurrentChange description] 弹窗 - 选择分页第几页
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            handleCurrentChange(val) {
                this.page.current = val;
                this.getList();
            },
            /**
             * [handleTableSelectionRowToggle description] 弹窗 - table单行 - 选中状态变化
             * @param  {[type]} selection [description]
             * @param  {[type]} row       [description]
             * @return {[type]}           [description]
             */
            handleTableSelectionRowToggle: function(selection, row) {
                let userIds = this.multipleSelection;
                let specs = this.specSelection;

                if(selection.length > 0) {
                    for(let i = 0; i < selection.length; i++) {
                        if(selection[i].id == row.id) {
                            if(userIds.indexOf(row.id) == -1) {
                                userIds.push(row.id);
                                // 规格id
                                if(this.limit === 1) {
                                    specs.push(this.getSpecId(row))
                                }
                            }
                            break;
                        }

                        if(i == selection.length - 1) {
                            userIds.splice(userIds.indexOf(row.id), 1);
                            // 规格id
                            if(this.limit === 1) {
                                specs.splice(specs.indexOf(this.getSpecId(row)), 1);
                            }
                        }
                    }
                } else {
                    userIds.splice(userIds.indexOf(row.id), 1);
                    // 规格id
                    if(this.limit === 1) {
                        specs.splice(specs.indexOf(this.getSpecId(row)), 1);
                    }
                }

                this.multipleSelection = Array.from(new Set(userIds));
                this.specSelection = Array.from(new Set(specs));
            },
            getSpecId(row) {
                const list = row.sku.specificationDetailList
                for(let i = 0; i < list.length; i++) {
                    const record = list[i]
                    if(row.firstValue == record.firstValue && row.secondValue == record.secondValue && row.thirdValue == record.thirdValue) {
                        return record.id
                    }
                }
            },
            /**
             * [handleTableSelectionAllToggle description] 弹窗 - table全部 - 选中状态变化
             * @param  {[type]} val [description] 选中行的数据集合array
             * @return {[type]}     [description]
             */
            handleTableSelectionAllToggle: function(val) {
                let userIds = this.multipleSelection;

                if(val.length > 0) {
                    for(let i = 0; i < val.length; i++) {
                        let valItem = val[i],
                            index = userIds.indexOf(valItem.id);
                        
                        if(index == -1) {
                            userIds.push(valItem.id)
                        }
                    }
                } else {
                    let tableData = this.tableData;

                    if(tableData.length > 0) {
                        for(let i = 0; i < tableData.length; i++) {
                            let index = userIds.indexOf(tableData[i].id);

                            if(index > -1) {
                                userIds.splice(index, 1);
                            }
                        }
                    }
                }

                this.multipleSelection = Array.from(new Set(userIds));
            },
            /**
             * [handleSelectionEnsure description]  指定用户 - 弹窗 - 确定选中
             * @return {[type]} [description]
             */
            handleSelectionEnsure: function() {
                this.visible = false;
                if(this.limit === 1) {
                    // 需要选择规格
                    this.$emit('ids', {
                        ids: this.multipleSelection,
                        specs: this.specSelection
                    });
                } else {
                    this.$emit('ids', this.multipleSelection);
                }
            }
        },
        mounted() {
            this.getList();
            this.getCategoryList()
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../common/styles/base/mixin-font";
    @import "../../common/styles/base/mixin-common";


    .select-mask{
        @include position(absolute, 3, 0, 0, 0, -42px);
        width: 42px;
        background: #FFF;
    }
}
